import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { fetchLatestData } from '../redux/action/customFile';
import { StayPreview, StayTable, guestCount } from './StayRecords';
import PageLoader from '../shared/PageLoader';
import './CheckInOut.css';

function ActiveInOut() {
    const [pdfFile, setPdfFile] = useState("");
    const [activeCheckinsMadina, setActiveCheckinsMadina] = useState([]);
    const [activeCheckinsMakkah, setActiveCheckinsMakkah] = useState([]);
    const [tab, setTab] = useState('madina');
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    const handleCurrentIN = () => {
        setLoading(true);
        fetchLatestData(
            "voucher/actve/in/out",
            {},
            (data) => {
                setActiveCheckinsMadina((data && data.activeCheckinsMadina) || []);
                setActiveCheckinsMakkah((data && data.activeCheckinsMakkah) || []);
                setLoading(false);
            },
            (err) => {
                console.log(err);
                setLoading(false);
            }
        );
    };

    useEffect(() => {
        handleCurrentIN();
    }, []);

    const madinaRows = activeCheckinsMadina || [];
    const makkahRows = activeCheckinsMakkah || [];
    const totalGuests = guestCount(madinaRows) + guestCount(makkahRows);

    if (pdfFile) {
        return <StayPreview pdfFile={pdfFile} onClose={() => setPdfFile("")} />;
    }

    return (
        <div className="cio-page">
            <div className="cio-header">
                <div className="cio-header-left">
                    <button type="button" className="cio-back" onClick={() => history.goBack()} title="Back">
                        <span className="mdi mdi-arrow-left" />
                    </button>
                    <div>
                        <h3>Currently in</h3>
                        <p>Guests checked in now in Madina and Makkah.</p>
                    </div>
                </div>
            </div>

            {loading ? (
                <PageLoader title="Loading guests" message="Please wait while we fetch in-house records." />
            ) : (
            <>
            <div className="cio-kpis">
                <div className="cio-kpi">
                    <div className="cio-kpi-icon" style={{ background: '#ecfdf5', color: '#059669' }}>
                        <span className="mdi mdi-account-group" />
                    </div>
                    <div>
                        <p>Total in-house</p>
                        <h4>{totalGuests}</h4>
                    </div>
                </div>
                <div className="cio-kpi">
                    <div className="cio-kpi-icon" style={{ background: '#eff6ff', color: '#1a73e8' }}>
                        <span className="mdi mdi-map-marker" />
                    </div>
                    <div>
                        <p>Madina</p>
                        <h4>{guestCount(madinaRows)}</h4>
                    </div>
                </div>
                <div className="cio-kpi">
                    <div className="cio-kpi-icon" style={{ background: '#f5f3ff', color: '#7c3aed' }}>
                        <span className="mdi mdi-city" />
                    </div>
                    <div>
                        <p>Makkah</p>
                        <h4>{guestCount(makkahRows)}</h4>
                    </div>
                </div>
            </div>

            <div className="cio-card">
                <div className="cio-tabs">
                    <button type="button" className={`cio-tab ${tab === 'madina' ? 'active' : ''}`} onClick={() => setTab('madina')}>
                        Madina
                    </button>
                    <button type="button" className={`cio-tab ${tab === 'makkah' ? 'active' : ''}`} onClick={() => setTab('makkah')}>
                        Makkah
                    </button>
                </div>
                {tab === 'madina' ? (
                    <StayTable
                        rows={madinaRows}
                        dateLabel="Check-in"
                        dateField="checkInMadina"
                        dateKind="in"
                        hotelField="hotelMadina"
                        roomField="roomTypeMadina"
                        onView={setPdfFile}
                    />
                ) : (
                    <StayTable
                        rows={makkahRows}
                        dateLabel="Check-in"
                        dateField="checkInMakkah"
                        dateKind="in"
                        hotelField="hotelMakkah"
                        roomField="roomTypeMakkah"
                        onView={setPdfFile}
                    />
                )}
            </div>
            </>
            )}
        </div>
    );
}

export default ActiveInOut;
